/**
 * Adaptive "lite" visuals — only after sustained scroll jank.
 * Conservative on purpose: one-off GC / extension hiccups must NOT trip this.
 * Overrides: ?tt-lite=1 (force on) · ?tt-lite=0 (force off + clear session)
 */
(function () {
  var STORAGE_KEY = 'tt-perf-lite-v2';
  var CLASS_NAME = 'tt-lite';
  var html = document.documentElement;

  // Drop the old oversensitive session flag so high-end PCs aren't stuck in lite.
  try {
    sessionStorage.removeItem('tt-perf-lite');
  } catch (e) {}

  function readOverride() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('tt-lite') === '1') return true;
      if (params.get('tt-lite') === '0') return false;
    } catch (e) {}
    return null;
  }

  function readSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeSession(on) {
    try {
      if (on) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function enableLite(reason) {
    if (html.classList.contains(CLASS_NAME)) return;
    html.classList.add(CLASS_NAME);
    writeSession(true);
    try {
      html.setAttribute('data-tt-lite-reason', reason || 'unknown');
    } catch (e) {}
  }

  function disableLite() {
    html.classList.remove(CLASS_NAME);
    writeSession(false);
    try {
      html.removeAttribute('data-tt-lite-reason');
    } catch (e) {}
  }

  var override = readOverride();
  if (override === true) {
    enableLite('override');
    return;
  }
  if (override === false) {
    disableLite();
    return;
  }
  if (readSession()) {
    enableLite('session');
    return;
  }

  // No heuristic auto-enable. Only proven sustained scroll jank (or manual override).
  var scrolling = false;
  var scrollIdleTimer = 0;
  var lastFrame = 0;
  var framesInGesture = 0;
  var windowFrames = 0;
  var windowTotalMs = 0;
  var jankBursts = 0;
  var watching = true;
  var rafId = 0;

  // Judge a whole window of scrolling rather than single frames: a machine pinned at
  // ~30fps never produces the one-off 48ms stalls the previous threshold looked for.
  var SLOW_AVG_MS = 28;
  var OUTLIER_MS = 220;
  var WARMUP_FRAMES = 10;
  var WINDOW_FRAMES = 30;
  var BURSTS_NEEDED = 2;

  function markScrolling() {
    scrolling = true;
    window.clearTimeout(scrollIdleTimer);
    scrollIdleTimer = window.setTimeout(function () {
      scrolling = false;
      lastFrame = 0;
      framesInGesture = 0;
      windowFrames = 0;
      windowTotalMs = 0;
    }, 160);
    if (!rafId && watching) rafId = window.requestAnimationFrame(sampleFrame);
  }

  function sampleFrame(now) {
    rafId = 0;
    if (!watching) return;

    if (scrolling) {
      if (lastFrame) {
        var delta = now - lastFrame;
        framesInGesture += 1;

        // Tab switch / long pause — drop the window, don't count as jank.
        if (delta > OUTLIER_MS) {
          windowFrames = 0;
          windowTotalMs = 0;
          lastFrame = now;
        } else if (framesInGesture > WARMUP_FRAMES) {
          windowFrames += 1;
          windowTotalMs += delta;

          if (windowFrames >= WINDOW_FRAMES) {
            var averageMs = windowTotalMs / windowFrames;
            windowFrames = 0;
            windowTotalMs = 0;

            if (averageMs > SLOW_AVG_MS) {
              jankBursts += 1;
              framesInGesture = 0;
              // A single slow window can be a one-off; require back-to-back ones.
              if (jankBursts >= BURSTS_NEEDED) {
                watching = false;
                enableLite('scroll-jank');
                cleanup();
                return;
              }
            } else {
              jankBursts = 0;
            }
          }
        }
      }
      lastFrame = now;
    } else {
      lastFrame = 0;
    }

    if (watching && scrolling) {
      rafId = window.requestAnimationFrame(sampleFrame);
    }
  }

  function cleanup() {
    window.removeEventListener('scroll', markScrolling);
    window.removeEventListener('touchmove', markScrolling);
    window.clearTimeout(scrollIdleTimer);
    if (rafId) window.cancelAnimationFrame(rafId);
  }

  window.addEventListener('scroll', markScrolling, { passive: true });
  window.addEventListener('touchmove', markScrolling, { passive: true });

  window.setTimeout(function () {
    if (watching && !html.classList.contains(CLASS_NAME)) {
      watching = false;
      cleanup();
    }
  }, 60000);
})();
